import template from './access_denied.html'
import controller from './access_denied.controller';
import './access_denied.scss';

let access_deniedComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default access_deniedComponent;



// WEBPACK FOOTER //
// ./client/app/components/access_denied/access_denied.component.js